<template>
  <div class="main-width">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>产品列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 搜索条件 -->
    <div class="fil">
      <CustomerListFilter @on-filter-change="handleFilter"></CustomerListFilter>
      <div class="fil__right">
        <el-image class="fil__right__img" fit="cover" src="~assets/img/customer/customer_filter_right_img_bg.png"></el-image>
        <div class="fil__right__btn" @click='handleCooperate'>我要合作</div>
      </div>
    </div>

    <!-- 产品列表 -->
    <ListProductSkeleton :loading="productLoading">
      <div v-if="productList.length">
        <div class="product__container">
          <CustomerProductList :products="productList"></CustomerProductList>
        </div>
        <div class="pagination__wrapper" v-if="pages.total_page > 1">
          <div @click="handleCooperate">
            <el-pagination layout="prev, pager, next" style="pointer-events: none;" :currentPage="pages.page_index" :total="pages.total_count" :pageSize="pages.page_size" />
          </div>
        </div>
      </div>
      <el-empty description="很抱歉，您筛选信息，暂未匹配到" :image="emptyImg" v-else />
    </ListProductSkeleton>
    <SettleTipFooterBanner />
    <FixedHoverNav bottom="150px" />
  </div>
</template>
<script>
// S components
import CustomerListFilter from "@/views/customer/CustomerListFilter.vue";
import CustomerProductList from "@/views/customer/CustomerProductList.vue";
import SettleTipFooterBanner from "@/views/customer/SettleTipFooterBanner.vue";
import ListProductSkeleton from "@/views/product/ListProductSkeleton.vue";
import FixedHoverNav from "~/components/FixedHoverNav.vue";

// Apis
import { getProductCustomerList } from "~/services/product";

// const
import {
  // MESSAGE_TYPES,
  // NOTIFY_GROUPS,
  REQUEST_CODES,
} from "@/constants/const-http";

// helpers
import { pick } from "@/utils/helpers.js";

function createSearchData() {
  return {
    months: [],
    days: [],
    date: [],
    price_section: [],
  };
}
function createDefaultPages() {
  return {
    total_count: 1,
    page_index: 1,
    page_size: 10,
    page_count: 1,
    total_page: 1,
  };
}

function transformRange(values = []) {
  return values
    .map((value) => value.split("-"))
    .map(([gte, lte]) => ({ gte, lte }));
}

export default {
  layout: "Main",
  auth: false,
   head: {
    title: "上船吧 多品类高端产品资源",
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: `【上船吧】（www.shangchuanba.com），丰富高端的产品资源+行业内低价优势。`
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: `上船吧，分销平台,长江游轮，江山如此多娇，问鼎三峡，临江仙，江城子，长江探索号，世纪传奇号，新东方快车，松赞旅行，Club Med，丽江，桂林，雪村，丽世，诺图格，星拓邦，半山·秘境，北疆，香格里拉，招商伊敦号`
      }
    ],
  },
  components: {
    CustomerListFilter,
    CustomerProductList,
    SettleTipFooterBanner,
    ListProductSkeleton,
    FixedHoverNav,
  },
  data() {
    return {
      emptyImg: require("@/assets/img/customer/customer_products_empty.png"),
      productList: [],
      searchData: createSearchData(),
      pages: createDefaultPages(),
      productLoading: true,
    };
  },
  computed: {
    auth() {
      return this.$auth.$state;
    },
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    async handleFilter(filterData) {
      this.pages.page_index = 1;
      // console.log(filterData)
      Object.assign(this.searchData, filterData);
      this.productLoading = true;
      let result = await this._getProductList();
      this.productLoading = false;
      this.setSearchResult(result);
    },
    async _getProductList() {
      const queryParmas = this.$route.query
      console.log({queryParmas})

      let { code, data, msg } = await getProductCustomerList({
        name: this.searchKeywords,
        ...this.searchData,
        days: transformRange(this.searchData.days),
        price_section: transformRange(this.searchData.price_section).map(
          ({ gte: gt, lte }) => ({ gt, lte })
        ),
        page_index: this.pages.page_index,
        page_size: this.pages.page_size,
        ...queryParmas
      });

      if (code !== REQUEST_CODES.ERROR_OK) {
        this.$message.error(msg);
        return { list: [], recommend: [], ...createDefaultPages() };
      }
      return Promise.resolve(data);
    },
    async handleSearch() {
      this.productLoading = true;
      let searchResult = await this._getProductList();
      this.productLoading = false;

      if (!searchResult.list.length) {
        this.noSearch = true;
        // return
      } else {
        this.noSearch = false;
      }
      this.setSearchResult(searchResult);
    },
    setSearchResult(data = {}) {
      console.log(data);
      let {
        page_count,
        page_index,
        page_size,
        total_count,
        total_page,
        list = [],
        recommend = [],
      } = data;
      Object.assign(this, {
        pages: {
          page_count,
          page_index,
          page_size,
          total_count,
          total_page,
        },
        productList: list,
        recommend,
      });
    },
    handleCooperate() {
      if (this.auth.loggedIn) {
        this.$router.push("/settled/process");
      } else {
        this.$store.commit('setVisibleRegisterModal', true);
      }
    },
  },
};
</script>
<style lang="scss" scoped>

.breadcrumb {
  padding: 18px 0;
}
.fil {
  display: flex;
  margin-bottom: 25px;
  &__right {
    width: 336px;
    height: 255px;
    margin-left: 10px;
    position: relative;
    &__btn {
      position: absolute;
      bottom: 24px;
      width: 175px;
      color: #212529;
      font-size: 21px;
      text-align: center;
      border-radius: 46px;
      height: 46px;
      line-height: 46px;
      background: linear-gradient(180deg, #fffd00 0%, #ffbe00 100%);
      font-weight: 600;
      left: 50%;
      transform: translateX(-50%);
      cursor: pointer;
      user-select: none;
      &:hover {
        background: linear-gradient(180deg, #ffd400 0%, #ff8a00 100%);
      }
    }
    &__img {
      width: 336px;
      height: 255px;
      border-radius: 6px;
    }
  }
}
.pagination {
  &__wrapper {
    text-align: center;
    padding: 0 0 40px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    > div {
      user-select: none;
    }
  }
}
.product__container {
  padding-bottom: 20px;
}

</style>